import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '../../queryKeys';
import { passport } from '../Passport';

type OptionsType = {
  enabled: boolean;
};

// Failed requests come back without `success`, so treat them as query errors.
// Successful data keeps the hooks' existing `T | undefined` type.
const unwrap = <T>(response: { success: boolean; data?: T }) => {
  if (response?.success !== true) throw new Error('Passport request failed');
  return response.data as T;
};

export const usePassport = (search: string, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.passports, search],
    queryFn: async () => unwrap(await passport.postPassport(search)),
    enabled: options?.enabled,
    retry: false,
  });

export const usePassportJobs = (search: string, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.passportsJobs, search],
    queryFn: async () => unwrap(await passport.postPassportJobs(search)),
    enabled: options?.enabled,
    retry: false,
  });

export const usePassportTransactions = (
  search: string,
  options?: OptionsType,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.passportsTransactions, search],
    queryFn: async () =>
      unwrap(await passport.postPassportTransactions(search)),
    enabled: options?.enabled,
    retry: false,
  });

export const usePassportArrivals = (search: string, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.passportsArrivals, search],
    queryFn: async () => unwrap(await passport.getPassportArrivals(search)),
    enabled: options?.enabled,
    retry: false,
  });
